import { CLIENTS, INDEX } from '../../applications';

export const environment = {
  production: false,
  APP_VERSION: '1.0.0',
  APP_NAME: CLIENTS.find((client) => client.index === INDEX)?.appName || 'Diet Fit',
  IDENTIFIER: CLIENTS.find((client) => client.index === INDEX)?.identifier || 'testing',
  LOGIN_PAGE: 'onboarding',
  IS_INTERNAL: CLIENTS.find((client) => client.index === INDEX)?.identifier === 'testing' ? true : false,
  API_URL: 'https://console.dietmaster.fit/api/customer/',
  // API_URL: 'https://foodna.dietmaster.fit/api/customer/',
  // API_URL: "http://localhost:8000/api/customer/",
  // TABBY_PUBLIC_KEY: "pk_test_0ac0699f-11ef-4183-99f0-063a5bb28084",
  // TABBY_MERCHANT_CODE: "EatSmartkwt"
};

export const IDENTIFIER_CONFIGS = {
  // Config for the 'testing' identifier (the default)
  testing: {
    showConsultations:true,
    showCommunity:true,
    showOnlineOrders:true,
    showPrefrences:true,
    onboardingPage:1,
    showCelebrity:false
  },
  
  lofat: {
    showConsultations:true,
    showCommunity:true,
    showOnlineOrders:false,
    showPrefrences:true,
    onboardingPage:2,
    showCelebrity:false
  },
    ghadana: {
    showConsultations:true,
    showCommunity:true,
    showOnlineOrders:false,
    showPrefrences:false,
    onboardingPage:1,
    showCelebrity:false
  },
  abietadm: {
    showConsultations:true,
    showCommunity:true,
    showOnlineOrders:false,
    showPrefrences:false,
    onboardingPage:1,
    showCelebrity:false
  },
    healthchart: {
    showConsultations:true,
    showCommunity:true,
    showOnlineOrders:false,
    showPrefrences:false,
    onboardingPage:1,
    showCelebrity:false
  },
    roots: {
    showConsultations:true,
    showCommunity:true,
    showOnlineOrders:false,
    showPrefrences:false,
    onboardingPage:1,
    showCelebrity:false
  },
  
};

export const identifierSpecificProperty = IDENTIFIER_CONFIGS[
  environment.IDENTIFIER as keyof typeof IDENTIFIER_CONFIGS
] || IDENTIFIER_CONFIGS.testing; // Fallback to 'testing' if identifier is not found
